/**
 * AIChordGeneratorWrapper Component
 * Wrapper for AI Chord Generator with track integration logic
 */

import React from 'react';
import { AIChordGenerator } from '../ai';
import { toast } from 'sonner';

export const AIChordGeneratorWrapper = ({
  isOpen,
  onClose,
  audioContext,
  tracks,
  bpm,
  updateTrack,
  setTracks,
  TRACK_COLORS,
}) => {
  const handleInsertProgression = (chords, metadata) => {
    // Find or create an instrument track for the chords
    const instrumentTrack = tracks.find(t => t.type === 'instrument' || t.type === 'midi');
    
    if (instrumentTrack) {
      // Convert chords to MIDI events
      const midiEvents = [];
      let currentTime = 0;
      const beatDuration = 60 / bpm; // seconds per beat
      
      chords.forEach((chord, index) => {
        const duration = (chord.duration_beats || 4) * beatDuration;
        
        (chord.midi_notes || []).forEach(note => {
          midiEvents.push({
            note,
            velocity: 100,
            startTime: currentTime,
            duration: duration * 0.95, // Slight gap between chords
          });
        });
        
        currentTime += duration;
      });
      
      // Add MIDI events to track
      updateTrack(instrumentTrack.id, {
        midiEvents: [...(instrumentTrack.midiEvents || []), ...midiEvents],
      });
      
      toast.success(`Added ${chords.length} chords to ${instrumentTrack.name}`);
    } else {
      // Create new MIDI track with chords
      const newTrack = {
        id: `track-${Date.now()}`,
        name: `Chords (${metadata.key} ${metadata.scale})`,
        type: 'midi',
        volume: 0.8,
        pan: 0,
        mute: false,
        solo: false,
        armed: false,
        color: TRACK_COLORS[tracks.length % TRACK_COLORS.length],
        midiEvents: [],
        midiClips: [{
          id: `clip-${Date.now()}`,
          name: `${metadata.genre} ${metadata.mood} Chords`,
          startTime: 0,
          duration: chords.length * (60 / bpm) * 4,
          notes: chords.flatMap((chord, chordIndex) => 
            (chord.midi_notes || []).map(note => ({
              note,
              velocity: 100,
              start: chordIndex * 4,
              duration: 3.8,
            }))
          ),
        }],
      };
      
      setTracks(prev => [...prev, newTrack]);
      toast.success(`Created new MIDI track with ${chords.length} chords`);
    }
  };

  return (
    <AIChordGenerator
      isOpen={isOpen}
      onClose={onClose}
      audioContext={audioContext}
      onInsertProgression={handleInsertProgression}
    />
  );
};

export default AIChordGeneratorWrapper;
